export const PARAM_PHONE_NUMBER = 'phoneNumber'

// Query params
export const PARAM_IS_HEADER_MINI_APP = 'isHeaderMiniApp'
export const PARAM_IS_HEADER_MINI_APP_EXPAND = 'isHeaderMiniAppExpand'
export const PARAM_IS_EMBEDDED_VIEW = 'isEmbeddedView'
export const PARAM_APIKEY = 'apikey' // apikey cố định mặc định cho app chứ ko phải để chuyển link
export const PARAM_PAYMENT_METHOD = 'paymentMethod' // phương thức thanh toán cố định mặc định 1 thanh toán
export const PARAM_HIDE_PAYMENT_METHOD = 'hidePaymentMethod' // phương thức thanh toán cố định mặc định 1 thanh toán
export const PARAM_USERNAME_PREFIX = 'usernamePrefix' // gắn trên username cơ bản để biết được là user của đối tác nào
export const PARAM_ENABLE_AUTO_RENEW = 'enableAutoRenew' // Bật tăts gia hạn tự động

// Referral params
export const PARAM_REFER_STATION_ID = 'referStationId'
export const PARAM_REFER_USER_ID = 'referUserId'
export const PARAM_REFER_STATION_CODE = 'referStationCode'
export const PARAM_REFER_USER_CODE = 'referUserCode'
export const PARAM_IS_DISPLAY_REFER_USER_CODE = 'isDisplayReferUserCode'
export const PARAM_APP_THEME_NAME = 'appThemeName'
export const PARAM_PARTNER_NAME = 'partnerName'